function Logo({ size, platform }) {
  return (
    <div
      className={`flex h-[44px] items-center relative -bottom-3 ${
        platform ? "justify-center" : ""
      }`}
    >
      <img
        src="/favicon_lendy_white.png"
        width={platform ? 23 : size ? 30 : 35}
        height={platform ? 23 : size ? 30 : 35}
        alt="logo lendy"
        className={`object-contain ${
          platform ? "mt-[5px]" : "mt-[9px]"
        }  mr-4 `}
        quality={100}
        layout="fixed"
      />
      <img
        src="/logo_lendy_white.png"
        width={size ? size : 35}
        height={size ? size : 35}
        alt="logo lendy"
        quality={100}
        className="object-contain"
        layout="fixed"
      />
    </div>
  );
}

export default Logo;
